var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3227 13.1932H4.09716C3.8234 13.1932 3.56085 13.0845 3.36727 12.8909C3.17369 12.6973 3.06494 12.4348 3.06494 12.161V2.87109H12.3549V12.161C12.3549 12.4348 12.2461 12.6973 12.0525 12.8909C11.859 13.0845 11.5964 13.1932 11.3227 13.1932Z",
    stroke: "#D84315",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16113 10.1015V5.97266",
    stroke: "#D84315",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25781 10.1015V5.97266",
    stroke: "#D84315",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.87109H14.4188",
    stroke: "#D84315",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25776 0.808594H6.16112C5.88736 0.808594 5.62481 0.917345 5.43123 1.11092C5.23766 1.3045 5.12891 1.56705 5.12891 1.84081V2.87302H10.29V1.84081C10.29 1.56705 10.1812 1.3045 9.98765 1.11092C9.79407 0.917345 9.53152 0.808594 9.25776 0.808594Z",
    stroke: "#D84315",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBin);
export default __webpack_public_path__ + "static/media/RedBin.ffe151c1.svg";
export { ForwardRef as ReactComponent };